import { useContext } from 'react';
import { CartContext } from './Cart';

export default () => useContext(CartContext);
